module.exports = __webpack_public_path__ + "img/142.151343a6.jpg";